import { types, flow, applySnapshot } from 'mobx-state-tree';
import { pick } from 'lodash';
import { makeRequest } from 'js/services/Network';
import ItemListing from '../types/ItemListing';

export default types
  .model('MyTokensPage', {
    first_name: '',
    items: types.optional(types.array(ItemListing), []),
    page: 1,
    last_page: 0,
    count: 5,
    is_loading: false,
  })
  .views(self => ({
    get hasMorePages() {
      return self.page < self.last_page;
    },
  }))
  .actions(self => ({
    load: flow(function* flow(refresh = false) {
      let response;
      if (!self.is_loading) {
        refresh && applySnapshot(self, {});
        self.is_loading = true;
        try {
          response = yield makeRequest('my-tokens-data', null, pick(self, ['page', 'count']));
          self.first_name = response.data.first_name || '';
          self.last_page = response.data.tokens.last_page;
          response.data.tokens.data.forEach(item => self.items.push(item));
          self.is_loading = false;
        } catch (error) {
          self.is_loading = false;
          throw error;
        }
      }
      return response;
    }),
    loadMore() {
      if (self.page < self.last_page) {
        self.page++;
        self.load();
      }
    },
  }));
